import React from 'react';

const WrongNumber = () => (
  <div className="wrong-number">
    <div>There was a problem with this number. Please check, and try again. It must be:</div>
    <ul className="wrong-number__list">
      <li>a valid UK mobile number</li>
      <li>different to the number currently registered</li>
    </ul>
  </div>
);

export default WrongNumber;
